/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_MediaInputs */



/**
* | output |
* | --- |
* | "Media" |
*
* @param {Options_Quicktools_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_media = /** @type {((inputs?: Options_Quicktools_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Médias")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Media")
	if (locale === "ru") return /** @type {LocalizedString} */ ("СМИ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Medios de comunicación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिडिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mídia")
	return /** @type {LocalizedString} */ ("Media")
});